import { GameMode } from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';

export class BeheadedGameMode extends GameMode {
    static readonly NORMAL_AVALANCHE: string = 'NORMAL_AVALANCHE';
    static readonly FREESPIN_AVALANCHE: string = 'FREESPIN_AVALANCHE';
    static readonly SUPER_FREESPIN: string = 'SUPER_FREESPIN';
    static readonly SUPER_FREESPIN_AVALANCHE: string = 'SUPER_FREESPIN_AVALANCHE';
    static readonly SUPER_FREESPIN_END: string = 'SUPER_FREESPIN_END';
}
